module.exports = __webpack_public_path__ + "static/pl-rate-drop-0d0b00d0cf241c23408c410abcfc54a4.png";